import { Type } from "@sinclair/typebox";
import SchemaValidator from "../../../schema-validator";

const rightClickBlockedEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("user action"),
		name: Type.Literal("right click blocked"),
		time: Type.Date(),
		details: Type.Object({
		}),
	}),
);

const printingBlockedEvent = new SchemaValidator(
	Type.Object({
		type: Type.Literal("user action"),
		name: Type.Literal("printing blocked"),
		time: Type.Date(),
		details: Type.Object({
		}),
	}),
);
export default {
	rightClickBlockedEvent,
	printingBlockedEvent,
};
